import { useEffect, useState } from 'react';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { To, useNavigate } from 'react-router-dom';

import { ChecklistItem } from 'us-react-components/dist/ChecklistItem/ChecklistItem';
import { DateFormat, formatDateToString } from 'us-react-components/dist/utils/date';
import { SitterService } from 'us-web-services';
import { ModalName } from '../../modals/constants';
import { useModal } from '../../modals/modalContext';
import { useDependencies } from '../../dependencies';
import { Routes } from '../../Routes';

const SuccessGuide = (): JSX.Element => {
  const { services: { tracker }, stores: { sitter } } = useDependencies();
  const modal = useModal();
  const navigate = useNavigate();
  const { t } = useSharedTranslation(namespaces.caregiver);

  const { id = 0, reviewCount = 0, vimeoId = '' } = sitter.sitter || {};

  const [availability, setAvailability] = useState();
  const [schedule, setSchedule] = useState([]);

  const trackAndGo = (elementId: string, route: To): void => {
    tracker.track('clicked-button', { elementId });
    navigate(route);
  };

  const trackAndOpenModal = (modalName: ModalName): void => {
    tracker.track('opened-modal', { modalName });

    modal?.setModalName(modalName);
  };

  useEffect(() => {
    const now = new Date();
    const twoMonthsOut = new Date();

    twoMonthsOut.setDate(now.getDate() + 61);

    const config = {
      params: {
        sitterId: id,
        start: formatDateToString(now, DateFormat.API_DATE_TIME_FORMAT),
        end: formatDateToString(twoMonthsOut, DateFormat.API_DATE_TIME_FORMAT),
      },
    };

    const getAvailabilities = async (): Promise<void> => {
      try {
        const availabilities = (await SitterService.getAvailabilities(config)).data;
        setAvailability(availabilities.data);
      } catch (e) {
        console.warn(e);
      }
    };

    const getSchedules = async (): Promise<void> => {
      try {
        const schedules = (await SitterService.getSchedules(config)).data;
        setSchedule(schedules.data);
      } catch (e) {
        console.warn(e);
      }
    };

    if (id) {
      getAvailabilities();
      getSchedules();
    }
  }, []);

  return (
    <div>
      <h4 className='my-1 font-bold text-base'>{t('components.successGuide.heading')}</h4>
      <p className='mb-3'>{t('components.successGuide.body')}</p>
      <ChecklistItem
        title={t('components.successGuide.headingVideo')}
        completed={!!vimeoId && vimeoId.length > 0}
        onClick={(): void => trackAndGo('success-guide-video', Routes.sitter.video)}
      />
      <ChecklistItem
        title={t('components.successGuide.headingRecommendations')}
        completed={reviewCount > 0}
        onClick={(): void => trackAndOpenModal(ModalName.GetRecommendations)}
      />
      <ChecklistItem
        title={t('components.successGuide.headingAvailability')}
        completed={availability && schedule.length > 0}
        onClick={(): void => trackAndGo('add-availability', Routes.sitter.calendar)}
      />
    </div>
  );
};

export { SuccessGuide };
